import io from 'socket.io-client';
// const socket=io.connect("http://localhost:8000");
// const socket=io.connect("https://helpdeskapi.fidaglobal.com");
// const socket=io.connect("https://ims_api.fidaglobal.com");
// const socket=io.connect("https://imshdesk_api.smarthris.live");

const socket=io.connect(process.env.REACT_APP_WSOCKET_PATH);

export {socket}